import axios from 'axios'
import {
  GENDER_TYPE_ENUMS,
  KID_RELATION_TYPE_ENUMS,
  MARITAL_STATUS_TYPE_ENUMS,
  RELATION_TYPE_ENUMS,
  SPOUSE_GENDER_TYPE_ENUMS,
} from 'src/utils/constants/BuyPolicy'
import { getProposerMaritalStatus } from 'src/utils/commonMethods/buyPolicy'
import { getAge, getFullName } from 'src/utils/commonMethods'
import { getTokenForQrReport } from 'src/services/individualService'

export const getInsuranceDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getquickquotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getMedicalQuestions = async (token, providerId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getmedicalquestions?providerId=${providerId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const getFullQuote = async (token, fullQuoteData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/gethealthquote`,
    headers: { Authorization: `Bearer ${token}` },
    data: fullQuoteData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getFormattedRequestObjects = (gender, userForm, ageForm) => {
  const userDetails = {
    fullName: userForm.fullName,
    mobileNumber: userForm.mobileNumber,
    pincode: userForm.pinCode,
    gender,
    ageDetails: ageForm,
  }

  const proposerDetails = {
    fullName: userForm.fullName,
    firstName: userForm.fullName,
    lastName: null,
    dateOfBirth: null,
    email: null,
    phone: userForm.mobileNumber,
    height: null,
    weight: null,
    panNumber: null,
    aadharNumber: null,
    isNominee: false,
    age: ageForm.myAge ?? null,
    relation: RELATION_TYPE_ENUMS.SELF,
    gender: gender,
    maritalStatus: getProposerMaritalStatus(ageForm),
    address: {
      permanentAddress: {
        addressLine: '',
        landmark: '',
        pincode: '',
        city: '',
        state: '',
      },
      currentAddress: {
        addressLine: '',
        landmark: '',
        pincode: '',
        city: '',
        state: '',
      },
      isCurrentAddressPermanent: false,
    },
  }

  let memberDetails = []

  if (ageForm.myAge) {
    memberDetails.push({
      id: 1,
      firstName: userForm.fullName,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.myAge,
      relation: RELATION_TYPE_ENUMS.SELF,
      gender: gender,
      maritalStatus: getProposerMaritalStatus(ageForm),
    })
  }

  if (ageForm.spouseAge) {
    memberDetails.push({
      id: 2,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.spouseAge,
      relation: RELATION_TYPE_ENUMS.SPOUSE,
      gender: SPOUSE_GENDER_TYPE_ENUMS[gender],
      maritalStatus: MARITAL_STATUS_TYPE_ENUMS.married,
    })
  }

  if (ageForm.motherAge) {
    memberDetails.push({
      id: 3,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.motherAge,
      relation: RELATION_TYPE_ENUMS.MOTHER,
      gender: GENDER_TYPE_ENUMS.FEMALE,
      maritalStatus: MARITAL_STATUS_TYPE_ENUMS.married,
    })
  }

  if (ageForm.fatherAge) {
    memberDetails.push({
      id: 4,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.fatherAge,
      relation: RELATION_TYPE_ENUMS.FATHER,
      gender: GENDER_TYPE_ENUMS.MALE,
      maritalStatus: MARITAL_STATUS_TYPE_ENUMS.married,
    })
  }

  if (ageForm.motherInLawAge) {
    memberDetails.push({
      id: 5,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.motherInLawAge,
      relation: RELATION_TYPE_ENUMS.MOTHER_IN_LAW,
      gender: GENDER_TYPE_ENUMS.FEMALE,
      maritalStatus: MARITAL_STATUS_TYPE_ENUMS.married,
    })
  }

  if (ageForm.fatherInLawAge) {
    memberDetails.push({
      id: 6,
      firstName: null,
      lastName: null,
      dateOfBirth: null,
      height: null,
      weight: null,
      isNominee: false,
      age: ageForm.fatherInLawAge,
      relation: RELATION_TYPE_ENUMS.FATHER_IN_LAW,
      gender: GENDER_TYPE_ENUMS.MALE,
      maritalStatus: MARITAL_STATUS_TYPE_ENUMS.married,
    })
  }

  ageForm.kidsAge.forEach((kidsAgeDetails, index) => {
    if (kidsAgeDetails.age) {
      memberDetails.push({
        id: 7 + index,
        firstName: null,
        lastName: null,
        dateOfBirth: null,
        height: null,
        weight: null,
        isNominee: false,
        age: kidsAgeDetails.age,
        relation: KID_RELATION_TYPE_ENUMS[kidsAgeDetails.gender],
        gender: kidsAgeDetails.gender,
        maritalStatus: MARITAL_STATUS_TYPE_ENUMS.single,
      })
    }
  })

  return {
    userDetails,
    proposerDetails,
    memberDetails,
  }
}

export const getTrovityInsuranceDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getTrovityAssuredQuotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getFormattedMedicalQuestions = (medicalQuestionsData) => {
  medicalQuestionsData.forEach((medicalQuestion) => {
    medicalQuestion.detailAnswer = ''
    medicalQuestion.isApplicable = false
    if (medicalQuestion.subQuestions?.length) {
      medicalQuestion.subQuestions = getFormattedMedicalQuestions(
        medicalQuestion.subQuestions
      )
    }
  })

  return medicalQuestionsData
}

export const getFullQuoteRequestBody = (guestUserDetails) => {
  const policyHolderInfo = {
    firstName: guestUserDetails.proposerDetails.firstName,
    lastName: guestUserDetails.proposerDetails.lastName,
    dateOfBirth: guestUserDetails.proposerDetails.dateOfBirth,
    relation: guestUserDetails.proposerDetails.relation,
    gender: guestUserDetails.proposerDetails.gender,
    profession: guestUserDetails.proposerDetails.profession,
    mobileNumber: guestUserDetails.proposerDetails.phone,
    emailId: guestUserDetails.proposerDetails.email,
    aadharNo: guestUserDetails.proposerDetails.aadharNumber,
    panNo: guestUserDetails.proposerDetails.panNumber,
    maritalStatus: guestUserDetails.proposerDetails.maritalStatus,
    permanentAddress: {
      ...guestUserDetails.proposerDetails?.address?.permanentAddress,
      address:
        guestUserDetails.proposerDetails?.address?.permanentAddress.addressLine,
      country: 'IN',
    },
    currentAddress: {
      ...guestUserDetails.proposerDetails?.address?.currentAddress,
      address:
        guestUserDetails.proposerDetails?.address?.currentAddress.addressLine,
      country: 'IN',
    },
  }

  delete policyHolderInfo['address']

  const nomineeDetails = {
    nomineeFirstName: guestUserDetails.nomineeDetails.firstName,
    nomineeLastName: guestUserDetails.nomineeDetails.lastName,
    nomineeDateOfBirth: guestUserDetails.nomineeDetails.dateOfBirth,
    nomineeRelation: guestUserDetails.nomineeDetails.relation,
    nomineeGender: guestUserDetails.nomineeDetails.gender,
  }

  let insuredMemberDetails = []
  guestUserDetails.memberDetails.forEach((memberInfo) => {
    let memberInfoObject = {
      firstName: memberInfo.firstName,
      lastName: memberInfo.lastName,
      dateOfBirth: memberInfo.dateOfBirth,
      relation: memberInfo.relation,
      gender: memberInfo.gender,
      profession: memberInfo.profession,
      mobileNumber: guestUserDetails.proposerDetails.phone,
      emailId: guestUserDetails.proposerDetails.email,
      memberMedicalInfo: memberInfo.medicalQuestionnaire ?? [],
      height: memberInfo.height,
      weight: memberInfo.weight,
      maritalStatus: memberInfo.maritalStatus,
    }

    if (memberInfo.relation === RELATION_TYPE_ENUMS.SELF) {
      memberInfoObject = {
        ...policyHolderInfo,
        memberMedicalInfo: memberInfo.medicalQuestionnaire ?? [],
        height: guestUserDetails.proposerDetails.height,
        weight: guestUserDetails.proposerDetails.weight,
        maritalStatus: guestUserDetails.proposerDetails.maritalStatus,
      }
    }

    delete memberInfoObject['medicalQuestionnaire']

    insuredMemberDetails.push(memberInfoObject)
  })

  return {
    providerId: guestUserDetails.selectedQuote.providerId,
    insuranceId: guestUserDetails.selectedQuote.insuranceId,
    enquiryId: guestUserDetails.selectedQuote.enquiryId,
    mobileNumber: guestUserDetails.userDetails.mobileNumber,
    pincode: Number(guestUserDetails.userDetails.pincode),
    sumInsured: Number(guestUserDetails.selectedQuote.sumInsured),
    policyTenure: Number(guestUserDetails.policyTenurePeriod),
    policyHolderInfo,
    nomineeDetails,
    insuredMemberDetails,
    oldPolicyId: guestUserDetails.oldPolicyId,
  }
}

export const setPaymentInitiation = async (token, policyId) => {
  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/setpaymentinitiation?policyId=${policyId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const updatePaymentInfo = async (token, formData) => {
  let config = {
    method: 'put',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/updatepaymentinfo`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getKycStatus = async (token, policyId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getkycstatus?policyId=${policyId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getProviderDetails = async (token, providerId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getProviderFields?providerId=${providerId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}
export const getConfusedCustomerDetails = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/confusedCustomer`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const paymentRedirection = (paymentLink) => {
  window.open(paymentLink, '_self')
}

export const getPlanDetails = async (token, providerId, insuranceId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getHealthPlanDetails?providerId=${providerId}&insuranceId=${insuranceId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getComparedQuotes = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getComparedQuotes`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getAddress = async (pincode) => {
  let config = {
    method: 'get',
    url: `https://api.postalpincode.in/pincode/${pincode}`,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getPolicyDownload = async (token, enquiryId) => {
  let config = {
    method: 'get',
    responseType: 'blob',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getpolicydownload?enquiryId=${enquiryId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const verifyKYC = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/verifykyc`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const saveNSTPData = async (token, formData) => {
  let config = {
    method: 'Post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/saveNSTPData`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const verifyPaymentStatus = async (token, formData) => {
  let config = {
    method: 'Post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/verifyPaymentStatus`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const getAgeDetailsObject = (insuredMembersList) => {
  const ageDetails = {
    myAge: '',
    spouseAge: '',
    motherAge: '',
    fatherAge: '',
    motherInLawAge: '',
    fatherInLawAge: '',
    kidsAge: [],
  }

  insuredMembersList.forEach((memberListItem) => {
    switch (memberListItem.relation) {
      case RELATION_TYPE_ENUMS.SELF:
        ageDetails.myAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.SPOUSE:
        ageDetails.spouseAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.MOTHER:
        ageDetails.motherAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.FATHER:
        ageDetails.fatherAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.MOTHER_IN_LAW:
        ageDetails.motherInLawAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.FATHER_IN_LAW:
        ageDetails.fatherInLawAge = getAge(memberListItem.dateOfBirth)
        break
      case RELATION_TYPE_ENUMS.SON:
      case RELATION_TYPE_ENUMS.DAUGHTER:
        ageDetails.kidsAge.push({
          id: ageDetails.kidsAge.length + 1,
          gender: memberListItem.gender,
          age: getAge(memberListItem.dateOfBirth),
        })
        break
      default:
        break
    }
  })

  if (!ageDetails.kidsAge.length) {
    ageDetails.kidsAge = [
      {
        id: 1,
        gender: 'MALE',
        age: '',
      },
      {
        id: 2,
        gender: 'FEMALE',
        age: '',
      },
    ]
  }

  return ageDetails
}

export const getUserDetailsObject = (proposerData) => {
  const nomineeDetails = {
    firstName:
      proposerData.healthProposalQuoteRequest.nomineeDetails.nomineeFirstName,
    lastName:
      proposerData.healthProposalQuoteRequest.nomineeDetails.nomineeLastName,
    dateOfBirth:
      proposerData.healthProposalQuoteRequest.nomineeDetails.nomineeDateOfBirth,
    gender:
      proposerData.healthProposalQuoteRequest.nomineeDetails.nomineeGender,
    relation:
      proposerData.healthProposalQuoteRequest.nomineeDetails.nomineeRelation,
  }

  let proposerDetails = {
    ...proposerData.healthProposalQuoteRequest.policyHolderInfo,
    address: {
      currentAddress: {
        ...proposerData.healthProposalQuoteRequest.policyHolderInfo
          .currentAddress,
        addressLine:
          proposerData.healthProposalQuoteRequest.policyHolderInfo
            .currentAddress.address,
        pincode: Number(
          proposerData.healthProposalQuoteRequest.policyHolderInfo
            .currentAddress.pincode
        ),
      },
      permanentAddress: {
        ...proposerData.healthProposalQuoteRequest.policyHolderInfo
          .permanentAddress,
        addressLine:
          proposerData.healthProposalQuoteRequest.policyHolderInfo
            .permanentAddress.address,
        pincode: Number(
          proposerData.healthProposalQuoteRequest.policyHolderInfo
            .permanentAddress.pincode
        ),
      },
    },
    phone:
      proposerData.healthProposalQuoteRequest.policyHolderInfo.mobileNumber,
    panNumber: proposerData.healthProposalQuoteRequest.policyHolderInfo.panNo,
    email: proposerData.healthProposalQuoteRequest.policyHolderInfo.emailId,
  }

  const selectedQuote = { ...proposerData.healthPolicyDetails }
  let memberDetails = []
  proposerData.healthProposalQuoteRequest.insuredMemberDetails.forEach(
    (memberInfo) => {
      let memberInfoObject

      if (memberInfo.relation === RELATION_TYPE_ENUMS.SELF) {
        memberInfoObject = {
          ...proposerDetails,
          medicalQuestionnaire: memberInfo.memberMedicalInfo ?? [],
        }
        proposerDetails = {
          ...proposerDetails,
          height: memberInfo.height,
          weight: memberInfo.weight,
        }
      } else {
        memberInfoObject = {
          ...memberInfo,
          medicalQuestionnaire: memberInfo.memberMedicalInfo ?? [],
          phone: memberInfo.mobileNumber,
          email: memberInfo.emailId,
        }
      }
      memberDetails.push(memberInfoObject)
    }
  )

  const userDetails = {
    pincode: Number(proposerDetails.permanentAddress.pincode),
    fullName: getFullName([
      proposerDetails.firstName,
      proposerDetails.lastName,
    ]),
    mobileNumber: proposerDetails.mobileNumber,
    gender: proposerDetails.gender,
    ageDetails: getAgeDetailsObject(memberDetails),
  }

  return {
    userDetails,
    nomineeDetails,
    proposerDetails,
    memberDetails,
    selectedQuote,
    oldPolicyId: proposerData.healthProposalQuoteRequest.oldPolicyId,
    policyTenurePeriod: proposerData.healthProposalQuoteRequest.policyTenure,
  }
}

export const getHealthKycRequestBody = (guestUserDetails) => {
  return {
    kycInfoRequest: {
      pan: guestUserDetails.proposerDetails.panNumber,
      dob: guestUserDetails.proposerDetails.dateOfBirth,
      enquiryId: guestUserDetails.selectedQuote.enquiryId,
      providerId: guestUserDetails.selectedQuote.providerId,
      insuranceId: guestUserDetails.selectedQuote.insuranceId,
    },
    healthProposalQuoteRequest: {
      ...getFullQuoteRequestBody(guestUserDetails),
    },
    healthPolicyDetails: { ...guestUserDetails.selectedQuote },
  }
}

export const getProposalDetails = async (token, enquiryId) => {
  let config = {
    method: 'get',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/getproposaldetails?enquiryId=${enquiryId}`,
    headers: { Authorization: `Bearer ${token}` },
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const downloadPolicyPDFDocument = async (
  fileName,
  documentId,
  documentURL = null,
  token
) => {
  const link = document.createElement('a')
  if (documentId) {
    let config = {
      method: 'get',
      url: `${process.env.REACT_APP_GATEWAY_URL}/download/dms/${fileName}/${documentId}`,
      responseType: 'blob',
      headers: { Authorization: `Bearer ${token}` },
    }
    return await axios(config).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      link.href = url
      link.setAttribute('download', `${fileName}`)
      link.setAttribute('target', '_blank')
      document.body.appendChild(link)
      link.click()
    })
  } else if (documentURL) {
    link.href = documentURL
    link.setAttribute('download', `${fileName}`)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
  } else {
    // do nothing
  }
}

export const saveISNPStatus = async (token, formData) => {
  let config = {
    method: 'post',
    url: `${process.env.REACT_APP_GATEWAY_URL}/purchase/v1/saveISNPStatus`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  }
  return await axios(config)
    .then((res) => {
      return { res }
    })
    .catch((err) => {
      return err
    })
}

export const fetchTokenForBuyPolicy = () => {
  return getTokenForQrReport()
    .then((responseToken) => {
      return responseToken.res.data.access_token
    })
    .catch((error) => {
      return error
    })
}
